import { GameReplicatedTimeout, GameReplicatedTimeoutConfig } from "../../../core/game/server/GameReplicatedTimeout";
class DeleteClueTimeout extends GameReplicatedTimeout {
    callback() {
        this.context.getReplicatedObjectById(this.data.clueId).commitDelete();
    }
}
export function createDeleteClueTimeout(data, context) {
    return context.createReplicatedTimeout('DeleteClueTimeout', data, [data.clueId]);
}
export const DeleteClueTimeoutConfig = new GameReplicatedTimeoutConfig('DeleteClueTimeout', DeleteClueTimeout);
//# sourceMappingURL=DeleteClueTimeout.js.map